export default __webpack_public_path__ + "static/media/kalevala.b58b659b.jpg";